import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import { EQScores } from '../models';


const KEY_ACTION = ActionType.GetEQScoresRequest;
const ACTIONS    = [
  ActionType.GetEQScoresRequest,
  ActionType.GetEQScoresResponse,
  ActionType.GetEQScoresError,
];


type Payload = EQScores;


type Meta = {
  releaseId: number;
};


/**
 * Dispatch this action to retrieve the scores associated with a particular release of a particular feedback report
 *
 * @param participantId - the database Id for the participant whose scores the report contains
 * @param releaseId - the database Id of the specific report release
 */
export const getEQScoresAction = (
  participantId: number,
  releaseId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.GetEQScores,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      participantId,
      releaseId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { releaseId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${releaseId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { releaseId } = action.meta;
  const metaTag       = `${releaseId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['eqScores', `${releaseId}`],
    payload,
    successState,
  );
};

export const getEQScoresReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
